import { EventEmitter, Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../auth/authentication.service";

@Injectable({
  providedIn: "root",
})
export class GlobalJobordersService {
  public getJODData$: EventEmitter<any>;
  public getJODContactData$: EventEmitter<any>;

  public refreshJobOrderData$: EventEmitter<any>;
  public refreshProcedureList$: EventEmitter<any>;
  public refreshJobOrderTask$: EventEmitter<any>;
  public refreshJobOrderProductData$: EventEmitter<any>;
  public refreshJobOrderPDFData$: EventEmitter<any>;

  private ENDPOINT_JOB_ORDER_TYPES_PICKLIST = "/job-order-types-pick-list";
  private ENDPOINT_JOB_ORDER_TYPE_BY_ID = "/job-order-type-by-id/";
  private ENDPOINT_TASK_TEMPLATE = "/ms/v1/tmpl-tasks/";
  private ENDPOINT_JOB_ORDERS_TEMPLATES = "/ms/v2/tmpl-job-orders";
  private ENDPOINT_JOB_PROCEDURE = "/job-order-procedures"; //procedure picklist
  private ENDPOINT_JOB_ORDER_TYPES = "/job-order-types";
  private ENDPOINT_JOB_ORDER_STATUSES = "/job-order-statuses";
  private ENDPOINT_JOB_ORDER_PROFILES_PICKLIST = "/profiles/picklist";
  private ENDPOINT_JOB_ORDER_STATUSES_V2 = "/v2/job-order-statuses";
  private ENDPOINT_JO_TYPE_JO_STATUSES_BY_JO_ID =
    "/jo-type-jo-statuses-to-check";
  private ENDPOINT_JOB_ORDER_STATUSES_V4 = "/v4/job-order-statuses";
  private ENDPOINT_JOB_ORDER_BASE = "/v5/job-orders";

  private ENDPOINT_UPLOAD_JO_TEMPLATE_ATTACHMENTS =
    "/v2/attachments/upload?parentType=TMPL_JOB_ORDER_ATTACHMENT";
  private ENDPOINT_UPLOAD_JO_TEMPLATE_ATTACHMENTS_NEW =
    "/attachments/upload?parentType=TMPL_JOB_ORDER_ATTACHMENT";
  private ENDPOINT_GET_TEMPLATE_ATTACHMENTS =
    "/attachments/by-parent?parentType=TMPL_JOB_ORDER_ATTACHMENT";

  private ENDPOINT_TASK_TEMPLATE_NEW = "/ms/v1/tmpl-job-orders";
  private ENDPOINT_PRODUCTS_BY_TASK_JOTMPL = "/v1/tmpl-task-products";
  private ENDPOINT_UPDATE_QTY_PRODUCT_JOTMPL = "/ms/v1/tmpl-job-order-products";
  private ENDPOINT_ADD_PARTS_JOTEMPLATE =
    "/ms/v1/tmpl-job-order-and-tmpl-task-products-refresh";
  private ENDPOINT_JO_TMPL_PICKLIST = "/ms/v1/tmpl-job-orders-pick-list";

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
  ) {
    this.getJODData$ = new EventEmitter();
    this.getJODContactData$ = new EventEmitter();

    this.refreshJobOrderData$ = new EventEmitter();
    this.refreshProcedureList$ = new EventEmitter();
    this.refreshJobOrderTask$ = new EventEmitter();
    this.refreshJobOrderProductData$ = new EventEmitter();
    this.refreshJobOrderPDFData$ = new EventEmitter();
  }

  changeJobOrderTab(tabName: any) {
    this.getJODData$.emit(tabName);
  }

  public setJOData(data: any) {
    this.getJODData$.emit(data);
  }

  public setJOContactData(data: any) {
    this.getJODContactData$.emit(data);
  }

  public getJobOrderTypes(active: any = null) {
    var tenantPackagesJO2 = this.auth.getPackageCodeWithList("JO2");
    let packageCode: any = localStorage.getItem("packageCode");
    let isJO2Avaialable: boolean;
    let addonFeature = this.auth.getAddonFeatureLists();

    if (packageCode == "Old") {
      isJO2Avaialable = addonFeature.addonJO2 == "JO2" ? true : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("JO2")) {
        isJO2Avaialable = tenantPackagesJO2.addonPackageList == "JO2" || addonFeature.addonJO2 == "JO2" ? true : false;
      } else {
        isJO2Avaialable = false;
      }
    }

    let active1 = "";
    if (active){
      active1 = "?isActive=true"+ (isJO2Avaialable ? "&profileBasedFilter=true" : "");
    }else{
      active1 = (isJO2Avaialable ? "?profileBasedFilter=true" : "");
    }

    return this.http
      .get(
        environment.base_url + this.ENDPOINT_JOB_ORDER_TYPES_PICKLIST + active1,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /********************************************* Get Job Order Type by ID *********************************************/
  public getJobOrderTypeById(joTypeId: number, includeStatuses: any = null, includeProfilePermissions: any = null) {
    let params = new HttpParams();
    if (includeStatuses){
      params = params.set("includeStatuses", includeStatuses);
    }
    if (includeProfilePermissions){
      params = params.set("includeProfilePermissions", includeProfilePermissions )
    }

    return this.http
      .get(
        environment.base_url + this.ENDPOINT_JOB_ORDER_TYPE_BY_ID + joTypeId,
        { params },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /********************************************* Get Job Order by ID *********************************************/
  public getJobOrderById(jobOrderId: number) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_JOB_ORDER_BASE + "/" + jobOrderId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /********************************************* Get Task Template List *********************************************/
  public getTaskTemplateList(search: string) {
    let params = new HttpParams().set("templateStatus", "ACTIVE");
    if (search) params = params.set("search", String(search));

    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_TASK_TEMPLATE}filter`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) return resp.body;
          return throwError(() => resp);
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getProcedures() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_JOB_PROCEDURE + "/pick-list")
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getPaginatedProcedures(search: any, parameters: any) {
    let params: any = new HttpParams();

    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_JOB_PROCEDURE +
          "/paged?isActiveOnly=false",
        { observe: "response", params },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getProcedureById(procedureId: number) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_JOB_PROCEDURE + "/" + procedureId,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createProcedure(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_JOB_PROCEDURE, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateProcedure(body: any) {
    return this.http
      .put(
        environment.base_url + this.ENDPOINT_JOB_PROCEDURE + "/" + body.id,
        body,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteProcedure(procedureId: number) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_JOB_PROCEDURE + "/" + procedureId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshProcedureList$.emit("Deleted Task Procedure");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public createJobOrderTemplate(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_JOB_ORDERS_TEMPLATES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJobOrderTemplateById(joTemplateId: number) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_JOB_ORDERS_TEMPLATES +
          "/" +
          joTemplateId +
          "?includeTasks=true",
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateJobOrderTemplate(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_JOB_ORDERS_TEMPLATES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getProductsByJOTemplateByTask(tmplTaskId: any, parameters: any) {
    let params = new HttpParams();

    if (tmplTaskId !== "" && tmplTaskId != null) {
      params = params.set("tmplTaskId", tmplTaskId);
    }

    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", parameters.pageSize)
        .set("columnName", parameters.columnName)
        .set("sortOrder", "asc");
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_PRODUCTS_BY_TASK_JOTMPL +
          "/filter",
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //update quantity for spare parts in jo template
  public updateQuantity(body: any) {
    return this.http
      .patch(
        environment.base_url +
          this.ENDPOINT_UPDATE_QTY_PRODUCT_JOTMPL +
          "/update-quantity?tmplJobOrderProductId=" +
          body.tmplJobOrderProductId +
          "&quantity=" +
          body.quantity,
        null,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //job order types related APIs
  public createJobOrderType(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_JOB_ORDER_TYPES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJobOrderTypeCategories() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_JOB_ORDER_TYPES + "/categories")
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public cloneJoType() {
    return this.http
      .post(
        environment.base_url + this.ENDPOINT_JOB_ORDER_TYPES + "/draft",
        {},
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateJobOrderType(body: any, joTypeId: number, section?: string) {
    let url: string = "";
    
    if (section === "basicInfo") url = "/basic-info/";
    else if (section === "form") url = "/form-info/";
    else if (section === "status") url = "/status-info/";
    else url = "/settings-info/";

    if (!section) {
      url = "";
    }

    return this.http
      .put(
        environment.base_url + this.ENDPOINT_JOB_ORDER_TYPES + url,
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateJobOrderTypePermissions(body: any, joTypeId: number) {
    //profile-permissions
     return this.http
      .put(
        environment.base_url + this.ENDPOINT_JOB_ORDER_TYPES + "/profile-permissions",
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJobOrderTypeStatusCategories() {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_JOB_ORDER_STATUSES + "/categories",
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getProfiles(IncludeUserCount?: boolean) {
    let url = environment.base_url + this.ENDPOINT_JOB_ORDER_PROFILES_PICKLIST;
    if (IncludeUserCount) url += "?IncludeUserCount=true";

    return this.http
      .get(url)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //create jo type's status
  public createJobOrderTypeStatus(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_JOB_ORDER_STATUSES_V2, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateJobOrderTypeStatus(body: any) {
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_JOB_ORDER_STATUSES_V2 +
          `/${body.jobOrderStatus.id}`,
        body,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJobOrderTypeStatusByJOTypeId(joTypeId: number) {
    let url: string = this.ENDPOINT_JO_TYPE_JO_STATUSES_BY_JO_ID;
    if (joTypeId) url = url + "?joTypeId=" + joTypeId;

    return this.http.get(environment.base_url + url).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  public getJobOrderTypeStatuses() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_JOB_ORDER_STATUSES_V4)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateJoTypeOrder(body: any) {
    return this.http
      .put(
        environment.base_url + this.ENDPOINT_JOB_ORDER_TYPES + "/order-update",
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /***************************** new API to get job order location based on customer, site, asset, project **********/
  getJobOrderLocationBaseOnCustomerSiteAssetProject(
    customerId: number,
    siteId: number,
    assetId: number,
    projectId: number,
  ) {
    let params = new HttpParams();
    if (customerId) params = params.set("customerId", customerId);
    if (siteId) params = params.set("siteId", siteId);
    if (assetId) params = params.set("assetId", assetId);
    if (projectId) params = params.set("projectId", projectId);

    return this.http
      .get(environment.base_url + this.ENDPOINT_JOB_ORDER_BASE + "/locations", {
        params,
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /***************************** new API to get job order contacts based on customer, site, project **********/
  getJobOrderContactBaseOnCustomerSiteAssetProject(
    customerId: number,
    siteId: number,
    projectId: number,
  ) {
    let params = new HttpParams();
    if (customerId) params = params.set("customerId", customerId);
    if (siteId) params = params.set("siteId", siteId);
    if (projectId) params = params.set("projectId", projectId);

    return this.http
      .get(environment.base_url + this.ENDPOINT_JOB_ORDER_BASE + "/contacts", {
        params,
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** create job order ******************************************/
  public createJobOrder(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_JOB_ORDER_BASE, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** Update job order ******************************************/
  public updateJobOrder(body: any, jobOrderId: number) {
    return this.http
      .put(
        environment.base_url + this.ENDPOINT_JOB_ORDER_BASE + `/${jobOrderId}`,
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** get JO Basic Details ******************************************/
  public getJobOrderBasicDetails(joId: number) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_JOB_ORDER_BASE +
          `/${joId}/basic-details`,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************* get JO Tasks *******************************/
  public getJOTasks(jobOrderId: any, parameters: any, showProcedureTasks: any = null, origin: any = null, searchParam?: string) {
    let params = new HttpParams();

    if (jobOrderId !== "" && jobOrderId != null)
      params = params.set("jobOrderId", jobOrderId);
    if (showProcedureTasks !== "" && showProcedureTasks != null)
      params = params.set("showProcedureTasks", showProcedureTasks);
    if (origin !== "" && origin != null) params = params.set("origin", origin);

    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", parameters.pageSize)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (searchParam && searchParam !== '') {
      params = params.set("search", searchParam);
    }
      return this.http
        .get(environment.base_url + "/task-list", {
          observe: "response",
          params,
        })
        .pipe(
          map((resp: any) => resp),
          catchError((error) => throwError(() => error)),
        );
  }

  /******************************* get JO Spare Parts *******************************/
  public getJOSpareParts(jobOrderId: any) {
    let params = new HttpParams();
    if (jobOrderId !== "" && jobOrderId != null)
      params = params.set("jobOrderId", jobOrderId);
    params = params.set("limit", 5);

    return this.http
      .get(environment.base_url + "/v4/job-order-products", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJOSparePartsByTasks(taskTemplateIds: any) {
    let params = new HttpParams();

    // if backend expects CSV string: taskTemplateIds.join(',')
    if (taskTemplateIds && taskTemplateIds.length) {
      params = params.set("taskTemplateIds", taskTemplateIds);
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_ADD_PARTS_JOTEMPLATE, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJOStatusById(statusId: number) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_JOB_ORDER_STATUSES_V2 +
          `/${statusId}`,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateStatusOrder(body: any) {
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_JOB_ORDER_STATUSES +
          "/order-update",
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public uploadJOAttachmentInForm(formData: any, id?: number) {
    let url: string = this.ENDPOINT_UPLOAD_JO_TEMPLATE_ATTACHMENTS;
    if (id) {
      url = url + `&parentId=${id}`;
    }
    url = url + `&jobOrderTemplateAttachment=true`;
    return this.http
      .post(environment.base_url + url, formData, { observe: "response" })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public uploadJOAttachmentInTab(formData: any, id?: number) {
    let url: string = this.ENDPOINT_UPLOAD_JO_TEMPLATE_ATTACHMENTS_NEW;
    if (id) {
      url = url + `&parentId=${id}`;
    }
    url = url + `&jobOrderTemplateAttachment=true`;
    return this.http
      .post(environment.base_url + url, formData, { observe: "response" })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJOTemplateAttachments(id?: number) {
    let url: string = this.ENDPOINT_GET_TEMPLATE_ATTACHMENTS;
    if (id) url = url + `&parentId=${id}`;

    return this.http.get(environment.base_url + url).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  //**================================== Upload Multiple File for JO  =========================*/
  public uploadMultipleJOAttachments(formData: any) {
    // If you already have an interceptor, you can REMOVE headers completely.
    const token = this.auth.getToken?.();
    const headers = token
      ? new HttpHeaders({ Authorization: "Bearer " + token })
      : new HttpHeaders();

    return this.http
      .post(
        environment.base_url + "/v2/attachments/upload?parentType=JO_ATTACHENT",
        formData,
        {
          observe: "response",
          headers,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== Delete Attachment =========================*/
  public deleteAttachment(id: any) {
    return this.http
      .delete(environment.base_url + "/attachments/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** get JO Recent Activity ******************************************/
  public getJORecentActivity(jobOrderId: any) {
    const params = new HttpParams().set("limit", 5);

    return this.http
      .get(
        environment.base_url +
          "/job-order-audit-event-histories/by-job-order/" +
          jobOrderId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** Update Job Order Owner ******************************************/
  public updateJobOrderOwner(ownerId: any, jobOrderId: any) {
    // PATCH body must be first, options second
    return this.http
      .patch(
        environment.base_url +
          this.ENDPOINT_JOB_ORDER_BASE +
          "/" +
          jobOrderId +
          "/owner?ownerId=" +
          ownerId,
        null,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshJobOrderData$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** remove job order owner ******************************************/
  removeJobOrderOwner(jobOrderId: any) {
    // PUT body first, options second
    return this.http
      .put(
        environment.base_url + `/job-orders/remove-owner?id=${jobOrderId}`,
        null,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshJobOrderData$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** get Job Order Completion Details ******************************************/
  public getJobOrderCompletionDetails(jobOrderId: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_JOB_ORDER_BASE +
          "/" +
          jobOrderId +
          "/completion-details",
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //GET task template list inside view jo template UI with old UI
  public getAllTaskTemplates_(
    search: any,
    parameters: any,
    siteId: any,
    projectId: any,
    teamId: any,
    tmplJobOrderId: any,
    skipTaskListIds: any,
    other: any,
    templateStatus: any,
  ) {
    let params = new HttpParams();

    if (search) params = params.set("search", search);
    if (siteId) params = params.set("siteId", siteId);
    if (projectId) params = params.set("projectId", projectId);
    if (teamId) params = params.set("teamId", teamId);
    if (templateStatus) params = params.set("templateStatus", templateStatus);
    if (tmplJobOrderId) params = params.set("tmplJobOrderId", tmplJobOrderId);
    if (skipTaskListIds)
      params = params.set("skipTaskListIds", skipTaskListIds);

    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_TASK_TEMPLATE + "/picklist", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //GET the tasks list/ procedure list in view jo template in new UI
  public getAllTasks(
    search: any,
    taskStatus: any,
    procedureId: any,
    tmplJobOrderId: any,
    showProcedureTasks: boolean,
  ) {
    let params = new HttpParams();

    if (search) params = params.set("search", search);
    if (taskStatus) params = params.set("taskStatus", taskStatus);
    if (procedureId) params = params.set("procedureId", procedureId);
    if (showProcedureTasks !== null && showProcedureTasks !== undefined) {
      params = params.set("showProcedureTasks", String(showProcedureTasks));
    }

    params = params
      .set("page", "1")
      .set("perPage", "100")
      .set("columnName", "taskOrder")
      .set("sortOrder", "asc");

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_TASK_TEMPLATE_NEW +
          "/" +
          tmplJobOrderId +
          "/tasks",
        { observe: "response", params },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  addProcedureToJobOrder(jobOrderId: any, procedureId: any) {
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_JOB_ORDER_BASE +
          `/add/procedure?jobOrderId=${jobOrderId}&procedureId=${procedureId}`,
        null,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshJobOrderTask$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  appenTasksToJOTemplate(body: any, joTemplateId: any) {
    return this.http
      .patch(
        environment.base_url +
          this.ENDPOINT_TASK_TEMPLATE_NEW +
          "/append-task-templates/" +
          joTemplateId,
        body,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  updateAssigneeOfTask(body: any) {
    let params = new HttpParams();
    if (body) {
      params = params
        .set("tmplJobOrderId", body.tmplJobOrderId)
        .set("tmplJobOrderTaskId", body.tmplJobOrderTaskId);

      if (body.userId) {
        params = params.set("userId", body.userId);
      }

      if (body.userGroupId) {
        params = params.set("userGroupId", body.userGroupId);
      }
    }

    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_TASK_TEMPLATE_NEW +
          "/assign-users",
        null,
        { observe: "response", params: params },
      )
      .pipe(
        map(
          (resp: any) => {
            return resp;
          },
          catchError((error) => {
            //console.log(error);
            return throwError(error);
          }),
        ),
      );
  }

  //remove procedure (it will remove all the tasks in procedure)
  deleteProcedureFromJOTemlate(
    procedureId: any,
    taskId: any,
    tmplJobOrderId: any,
  ) {
    let params = new HttpParams();
    if (tmplJobOrderId) params = params.set("tmplJobOrderId", tmplJobOrderId);
    if (procedureId) params = params.set("procedureId", procedureId);
    if (taskId) params = params.set("taskId", taskId);

    return this.http
      .delete(
        environment.base_url +
          this.ENDPOINT_TASK_TEMPLATE_NEW +
          "/remove-tasks",
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** remove procedure from job order ******************************************/
  removeProcedureFromJobOrder(jobOrderId: any, procedureId: any, taskId: any) {
    let params = new HttpParams();
    if (procedureId) params = params.set("procedureId", procedureId);
    if (taskId) params = params.set("taskId", taskId);
    if (jobOrderId) params = params.set("jobOrderId", jobOrderId);

    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_JOB_ORDER_BASE + `/remove-tasks`,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshJobOrderTask$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************* get JO Product List *******************************/
  public getJOProductList(jobOrderId: number) {
    const params = new HttpParams().set("jobOrderId", jobOrderId);

    return this.http
      .get(environment.base_url + "/v5/job-order-products", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************* save JO Product  *******************************/
  public saveJobOrderProduct(body: any) {
    return this.http
      .post(environment.base_url + "/v5/job-order-products", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshJobOrderProductData$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }


  /******************************* send email with PDF  *******************************/
  public sendEmailPDF(body: any, jobOrder: any) {
    return this.http
      .post(
        environment.base_url + "/job-orders/email-completion/" + jobOrder,
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************* change task owner  *******************************/
  public changeTaskOwnerId(taskId: any, userId: any, userGroupId: any) {
    let params = new HttpParams().set("taskId", taskId);
    if (userId) params = params.set("userId", userId);
    if (userGroupId) params = params.set("userGroupId", userGroupId);

    return this.http
      .put(environment.base_url + "/tasks/change-user", null, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => {
          this.refreshJobOrderTask$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  getProductListBaseOnTaskTemplate(
    tmplJobOrderId: number,
    taskTemplateIds: any,
  ) {
    let params = new HttpParams().set("tmplJobOrderId", tmplJobOrderId);
    params = params.set("taskTemplateIds", taskTemplateIds);

    return this.http
      .get(
        environment.ms_base_url +
          "/v1/tmpl-job-order-and-tmpl-task-products-refresh",
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  getJOTemplatesPicklist() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_JO_TMPL_PICKLIST)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public jobOrderReAssign(data: any) {
    return this.http.put(environment.base_url + '/v5/job-orders/assign', data,{observe: "response"}).pipe(map((resp: any) => {
      this.refreshJobOrderData$.emit(resp); // Emit event to refresh the list after re-assigning
      return resp;
    }
    ), catchError(error => {
      return throwError(error);
    }),); 
  }
  // Replace the existing getPDFListByJOId method in global-joborders.service.ts
  // New method to get PDF list with pagination and sorting for Job Order Details page
  public getPDFListByJOId(search:any ,page: number, perPage: number, jobOrderId: any) {
    let params = new HttpParams()
    if (search !== "" && search != null) {
          params = params.set("search", search);
        }
      params = params.set('page', page.toString())
      .set('perPage', perPage.toString())
      .set('columnName', 'generated_on')
      .set('sortOrder', 'desc');

    return this.http
      .get(environment.base_url + '/v1/job-orders/' + jobOrderId + '/pdfs/filter', {
        observe: 'response',
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }
  // New method to regenerate PDF from Job Order Details page
  public regeneratePDF(jobOrderId: any, pdfId: any,body:any ) {
      return this.http
        .post(`${environment.base_url}/v1/job-orders/${jobOrderId}/pdfs/${pdfId}/regenerate`, body, { observe: "response" })
        .pipe(
          map((resp: any) => {
            this.refreshJobOrderPDFData$.emit(resp);
            return resp;
          }),
          catchError((error) => throwError(() => error))
        );
    }
  // New method to delete PDF from Job Order Details page
  public deleteJobOrderPDF(jobOrderId: any, pdfId: any) {
    return this.http
      .delete(`${environment.base_url}/v1/job-orders/${jobOrderId}/pdfs/${pdfId}`, { observe: "response" })
      .pipe(
        map((resp: any) => {
          this.refreshJobOrderPDFData$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }
  // New method to send email with PDF from Job Order Details page
  public sendJobOrderPDF(jobOrderId: any, pdfId: any, body: any) {
    return this.http
      .post(`${environment.base_url}/v1/job-orders/${jobOrderId}/pdfs/${pdfId}/email`, body, { observe: "response" })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }
    // New method to get email audit list for PDFs in Job Order Details page
  getPDFListEmailAudits(jobOrderId: number, page: number, perPage: number) {
    const params = new HttpParams()
      .set('jobOrderId', jobOrderId)
      .set('page', page)
      .set('perPage', perPage)
      .set('columnName', 'sent_at')
      .set('sortOrder', 'desc');

    return this.http.get(`${environment.base_url}/v1/job-orders/pdfs/email-audits/filter`, 
      { observe: 'response', params })
      .pipe(map((resp: any) => resp), catchError(error => throwError(() => error)));
  }
  // New method to get PDF templates list with pagination and sorting for Job Order Template creation/edit page
  getPDFTemplatesList(jobTypeId: number, page: number, perPage: number) {
    const params = new HttpParams()
      .set('jobTypeId', jobTypeId)
      .set('page', page)
      .set('perPage', perPage)
      .set('columnName', 'template_name')
      .set('sortOrder', 'asc')
      .set('status', 'ACTIVE')
    
    return this.http.get(`${environment.base_url}/v1/pdf-templates/filter`, 
      { observe: 'response', params })
      .pipe(map((resp: any) => resp), catchError(error => throwError(() => error)));
  }

  generateJobOrderPDF(jobOrderId: number, body: any) {
    return this.http
      .post(`${environment.base_url}/v1/job-orders/${jobOrderId}/pdfs/generate`, body, { observe: 'response' })
      .pipe(map((resp: any) => resp)
      , catchError(error => throwError(() => error)));
  }

  getJobOrderStatusCategoryByStatusName(statusName: string) {
    //job-order-statuses/by-status-name?name=xyz
    const params = new HttpParams().set('name', statusName);
    return this.http.get(`${environment.base_url}/job-order-statuses/by-status-name`, { observe: 'response', params })
      .pipe(map((resp: any) => resp), catchError(error => throwError(() => error)));
  }

  getJOSmartAssignInfo(jobOrderId: number, body: any) {
    //job-order-auto-assignment/5288/suggest-users-detailed
    const params = new HttpParams().set('jobOrderId', jobOrderId);
    return this.http.put(`${environment.base_url}/job-order-auto-assignment/${jobOrderId}/suggest-users-detailed`, body, { observe: 'response' })
      .pipe(map(
        (resp: any) => resp), 
        catchError(error => throwError(() => error))
      );
  }
}
